module.exports = __webpack_public_path__ + "media/images/emblems/fieschertal-c97b0dd3fe7d59ea124879ef11a22140.png";